import { avatarAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';
import { theme as defaultTheme } from '@chakra-ui/theme';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(avatarAnatomy.keys);

const baseStyle = definePartsStyle({
  container: defineStyle({
    bg: 'transparent',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'neutral.border-subtle',
    img: {
      borderRadius: 'inherit',
      height: '100%',
      objectFit: 'cover',
      width: '100%',
    },
  }),
  label: defineStyle({
    color: 'neutral.fg-tertiary',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    lineHeight: '1',
  }),
});

const variantRepublic = definePartsStyle({
  container: defineStyle({
    img: {
      border: 0,
    },
  }),
});

const sizes = {
  'republic-xs': defaultTheme.components.Avatar.sizes?.xs ?? {},
  'republic-sm': defaultTheme.components.Avatar.sizes?.sm ?? {},
  'republic-md': defaultTheme.components.Avatar.sizes?.md ?? {},
  'republic-lg': defaultTheme.components.Avatar.sizes?.lg ?? {},
  'republic-xl': defaultTheme.components.Avatar.sizes?.xl ?? {},

  '2xs': definePartsStyle({
    container: defineStyle({
      width: '16px',
      height: '16px',
      borderRadius: 'sm',
      img: { borderRadius: 'sm' },
    }),
    label: defineStyle({ fontSize: 'xs' }),
  }),
  xs: definePartsStyle({
    container: defineStyle({
      width: '20px',
      height: '20px',
      borderRadius: 'sm-md',
      img: { borderRadius: 'sm-md' },
    }),
    label: defineStyle({ fontSize: 'xs' }),
  }),
  sm: definePartsStyle({
    container: defineStyle({
      width: '24px',
      height: '24px',
      borderRadius: 'sm-md',
      img: { borderRadius: 'sm-md' },
    }),
    label: defineStyle({ fontSize: 'xs' }),
  }),
  md: definePartsStyle({
    container: defineStyle({
      width: '36px',
      height: '36px',
      borderRadius: 'md',
      img: { borderRadius: 'md' },
    }),
    label: defineStyle({ fontSize: 'sm' }),
  }),
  lg: definePartsStyle({
    container: defineStyle({
      width: '40px',
      height: '40px',
      borderRadius: 'md',
      img: { borderRadius: 'md' },
    }),
    label: defineStyle({ fontSize: 'sm' }),
  }),
  xl: definePartsStyle({
    container: defineStyle({
      width: '48px',
      height: '48px',
      borderRadius: 'lg',
      img: { borderRadius: 'lg' },
    }),
    label: defineStyle({ fontSize: 'sm-md' }),
  }),
  '2xl': definePartsStyle({
    container: defineStyle({
      width: '56px',
      height: '56px',
      borderRadius: 'lg',
      img: { borderRadius: 'lg' },
    }),
    label: defineStyle({ fontSize: 'sm-md' }),
  }),
  xxl: definePartsStyle({
    container: defineStyle({
      width: '160px',
      height: '160px',
      borderRadius: '2xl',
      img: { borderRadius: '2xl' },
    }),
  }),
};

export const Avatar = defineMultiStyleConfig({
  baseStyle,

  sizes,

  variants: {
    republic: variantRepublic,
  },
});
